export const TARGET_DESTINATION = 'targetDestination';
